import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '@/utils/jwt';

const AGENT_MCP_URL = import.meta.env.VITE_AGENT_MCP_URL as string | undefined;

export interface LlmHealthResponse {
  status: 'ok' | 'error';
  mode?: string;
  model?: string;
  error?: string;
}

export const healthApi = createApi({
  reducerPath: 'healthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: AGENT_MCP_URL ?? '/agent',
    prepareHeaders: (headers) => {
      const token = getAccessToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getLlmHealth: builder.query<LlmHealthResponse, undefined>({
      query: () => '/health/llm',
      // Re-check LLM health every 60 seconds
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useGetLlmHealthQuery } = healthApi;
